import React from "react";

import classes from "./MoreInformationModal.module.css";

import CloseIcon from "@mui/icons-material/Close";

const MoreInformationModal = ({ selectedData, onClose }) => {
  return (
    <div className={classes["main-wrapper"]}>
      <div className={classes["modal"]}>
        <div className={classes["box1"]}>
          <img className={classes["img"]} src={selectedData[0].img} alt="" />
        </div>
        <div className={classes["box2"]}>
          <p className={classes["name"]}>
            {selectedData[0].name} {selectedData[0].lastName}
          </p>
          <p className={classes["other-info"]}>
            - Experience: <span>{selectedData[0].experience} years</span>
          </p>
          <p className={classes["other-info"]}>
            - Workplace: <span>{selectedData[0].workplace}</span>
          </p>
          <p className={classes["other-info"]}>
            - Achievment: <span>{selectedData[0].achievments}</span>
          </p>
          <p className={classes["other-info"]}>
            - More informations: <span>{selectedData[0].moreInfo}</span>
          </p>
          <p className={classes["other-info"]}>
            - Number of students: <span>{selectedData[0].students}+</span>
          </p>
        </div>
        <CloseIcon
          className={classes["close-icon"]}
          onClick={onClose}
          fontSize="large"
        />
      </div>
    </div>
  );
};

export default MoreInformationModal;
